export default "__VITE_ASSET__E8RF1IUq__"